import { mediaItems } from '@/mocks/homeData';

export default function Media() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6">
          精彩剧集
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-50 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="w-10 h-10 flex items-center justify-center bg-background-50/90 rounded-full mx-auto">
                    <i className="ri-play-fill text-primary-500 text-xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 truncate">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}